import { useMemo } from 'react';

import { ReportSummaryRequestBaseParams, ReportTableRequestBaseParams } from '../ReportSummary';

import useMultipleEmployerSelectAvailable from './useMultipleEmployerSelectAvailable';

interface Params {
  isMultipleEmployerMode?: boolean;
}
const useIsEmployerIsPresent = (
  filterValues: ReportTableRequestBaseParams | ReportSummaryRequestBaseParams,
  params?: Params
) => {
  const isMultipleEmployerAvailable = useMultipleEmployerSelectAvailable();

  const currentVal = useMemo(() => {
    if (params?.isMultipleEmployerMode && isMultipleEmployerAvailable) {
      return true;
    }
    return !!filterValues.employerId;
  }, [isMultipleEmployerAvailable, params?.isMultipleEmployerMode, filterValues.employerId]);
  return currentVal;
};

export default useIsEmployerIsPresent;
